import { render, staticRenderFns } from "./Q&A.vue?vue&type=template&id=e6c92e9a&scoped=true&"
import script from "./Q&A.vue?vue&type=script&lang=js&"
export * from "./Q&A.vue?vue&type=script&lang=js&"
import style0 from "./Q&A.vue?vue&type=style&index=0&id=e6c92e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c92e9a",
  null
  
)

export default component.exports